// extracted by mini-css-extract-plugin
export default {"widgets":"addWidget_widgets__t9VDu","widgets-icon-background":"addWidget_widgets-icon-background__i81f1","no-data-customers":"addWidget_no-data-customers__KPkWb"};